import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import {
  BtnOutlineGreen,
  BtnOutlineOrange,
  BtnOutlineRed,
  ContFlexRight,
} from '../../../styled-components';
import DateInput from '../../../commons/DateInput';

const ModalCancellationUser = ({ profile, onConfirmCancellation }) => {
  const [t] = useTranslation('USERS');
  const [modal, setModal] = useState(false);
  const [modalCancel, setModalCancel] = useState(false);
  const [formValues, setFormValues] = useState({
    cancellationDate: profile.cancellationDate || '',
  });
  const [formErrors, setFormErrors] = useState({
    cancellationDate: false,
  });

  const onConfirm = () => {
    onConfirmCancellation(formValues.cancellationDate);
    setModal(false);
  };

  const onConfirmCancel = () => {
    onConfirmCancellation('');
    setFormValues({
      cancellationDate: '',
    });
    setModalCancel(false);
  };

  const toggle = () => setModal(!modal);
  const toggleCancel = () => setModalCancel(!modalCancel);

  return (
    <>
      <Row>
        <Col xs="12" md="6" lg="4">
          <FormGroup>
            <Label>{t('CANCELLATION_DATE')}</Label>
            <DateInput
              name="cancellationDate"
              value={formValues.cancellationDate}
              onChange={(cancellationDate) => {
                setFormValues((state) => ({
                  ...state,
                  cancellationDate,
                }));
              }}
            />
          </FormGroup>
        </Col>
      </Row>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
        <BtnOutlineRed
          type="button"
          disabled={!formValues.cancellationDate}
          onClick={toggleCancel}
        >
          {t('CONFIRM_CANCEL_CANCELLATION')}
        </BtnOutlineRed>

        <BtnOutlineOrange
          type="button"
          disabled={!formValues.cancellationDate}
          onClick={toggle}
        >
          {t('CONFIRM_CANCELLATION')}
        </BtnOutlineOrange>
      </div>

      <Modal isOpen={modal} fade={false}>
        <ModalHeader>{t('CONFIRM_CANCELLATION')}</ModalHeader>
        <ModalBody>
          <p>{t('DESCRIPTION_ON_CONFIRM_CANCELLATION')}</p>
        </ModalBody>
        <ModalFooter>
          <BtnOutlineRed type="button" className="uppercase" onClick={toggle}>
            {t('COMMON:CANCEL')}
          </BtnOutlineRed>
          <BtnOutlineGreen
            type="button"
            className="uppercase"
            onClick={onConfirm}
          >
            {t('COMMON:CONFIRM')}
          </BtnOutlineGreen>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalCancel} fade={false}>
        <ModalHeader>{t('CONFIRM_CANCEL_CANCELLATION')}</ModalHeader>
        <ModalBody>
          <p>{t('DESCRIPTION_ON_CONFIRM_CANCEL_CANCELLATION')}</p>
        </ModalBody>
        <ModalFooter>
          <BtnOutlineRed
            type="button"
            className="uppercase"
            onClick={toggleCancel}
          >
            {t('COMMON:CANCEL')}
          </BtnOutlineRed>
          <BtnOutlineGreen
            type="button"
            className="uppercase"
            onClick={onConfirmCancel}
          >
            {t('COMMON:CONFIRM')}
          </BtnOutlineGreen>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ModalCancellationUser;
